import { GameWeek } from '@shared/constants';
import {
  GameID,
  ITeamsOnByeWeek,
  SeasonID,
  SeasonTeamAbrvID,
  SeasonWeekID,
  TeamAbrvID,
  TeamAbrvType,
  TeamID,
  UID,
  WeekID,
} from '@shared/types';

export enum NFLConference {
  AFC = 'AFC', // American Football Conference
  NFC = 'NFC', // National Football Conference
}

export enum NFLDivision {
  AFCNorth = 'AFC North',
  AFCEast = 'AFC East',
  AFCSouth = 'AFC South',
  AFCWest = 'AFC West',
  NFCNorth = 'NFC North',
  NFCEast = 'NFC East',
  NFCSouth = 'NFC South',
  NFCWest = 'NFC West',
}

export interface ITeamSchedule {
  teamID: TeamID;
  year: number;
  opponents: ITeamStandings[];
}

export type FieldTurfType = 'ArtificialTurf' | 'NaturalGrass';

// export type TeamScheduleBySeasonYear = { [key: SeasonID]: UID[] };
// export interface ITeamDetails {
//   teamID: string;
//   teamAbrv: string;
//   teamName: string;
//   teamFullName: string;
//   teamLogo: string;
//   teamColor: string;
//   teamSecondaryColor: string;
//   teamConference: NFLConference;
//   teamDivision: NFLDivision;
//   teamCity: string;
//   teamState: string;
//   teamStadium: string;
//   teamCapacity: number;
//   teamStadiumHasRoof: boolean;
//   teamStadiumFieldType: FieldTurfType;
//   teamHeadCoach: string;
//   teamOffensiveCoordinator: string;
//   teamDefensiveCoordinator: string;
//   teamSpecialTeamsCoach: string;
//   teamOffensiveScheme: string;
//   teamDefensiveScheme: string;
//   teamBaseFormation: string;
//   teamBaseDefense: string;
//   teamBaseOffense: string;
//   teamBaseSpecialTeams: string;
//   teamRoster: string[];
//   schedule: UID[];
//   /** Regular season year, which goes from September - December */
//   scheduleByYear: TeamScheduleBySeasonYear;
//   /** Rivalries, used by Prediction calculator */
//   rivalries: TeamAbrvID[];
// }

export type WeeklyStandings = {
  [key in GameWeek]: ITeamWeeklyResult[];
};

export interface ITeamWeeklyStats {
  wins: number;
  losses: number;
  ties: number;
  pct: number;
  pf: number;
  pa: number;
  homeRecord: string;
  awayRecord: string;
  streak: number;
  inDivisionHomeRecord: string;
  inDivisionAwayRecord: string;
}

export interface ITeamStandings extends ITeamWeeklyStats {
  uID: UID; // ordered UID with leading weekID and teamID double digit numbers
  result: string;
  pointsScored: number;
  pointsAllowed: number;
  isHomeTeam: boolean;
  isByeWeek: boolean;
  seasonWeekID: SeasonWeekID;
}

export interface ITeamWeeklyResult extends ITeamWeeklyStats {
  teamID: TeamID;
  teamAbrv: string;
  gameID: GameID;
  result: string;
  pointsScored: number;
  pointsAllowed: number;
  isHomeTeam: boolean;
  isByeWeek: boolean;
}

export interface ITeamScheduleSmall {
  team: ITeam;
  year: number;
  opponents: IOpponentTeam[];
}

export interface IOpponentTeam {
  vsTeam: ITeam;
  weekID: GameWeek;
  gameID: GameID;
}

export interface ITeam {
  teamID: TeamID;
  teamAbrv: string;
}

export type TeamModel = {
  teamAbv: string;
  teamCity: string;
  teamName: string;
  teamID: string;
  division: string;
  conferenceAbv: string;
  conference: string;
  logoLgUrl: string;
  logoSmUrl: string;
};

export type TeamSeasonSchedule = UID[];

export type AllSeasonScheduleByTeamType = {
  [key: string]: TeamSeasonSchedule;
};

export type DeconstructedByeWeekID = {
  seasonID: SeasonID;
  weekID: WeekID;
  seasonWeekID: SeasonWeekID;
  teamID: TeamID;
  teamAbrv: TeamAbrvType;
  teamAbrvID: TeamAbrvID;
  seasonTeamAbrvID: SeasonTeamAbrvID;
};

export type TeamsOnByeWeekBySeasonWeek = {
  [key in SeasonWeekID]: ITeamsOnByeWeek;
};
